import failPayment from "../images/faildPayment.svg";

const PaymentFail = () => {
  return (
    <div
      id="paymentFaild"
      className="bg-white flex flex-col justify-center items-center min-h-screen"
    >
      <div className="grid gap-10 justify-self-center px-10 md:px-0">
        <div></div>
        <div className="flex flex-col text-center gap-10">
          <div className="grid justify-center">
            <img
              className="w-32 h-32 md:w-44 md:h-44"
              src={failPayment}
              alt="noImg"
            />
          </div>
          <div>
            <div className="flex flex-col gap-2">
              <h1 className="text-xl md:text-4xl font-semibold">
                Payment Failed
              </h1>
              <p className="text-[#af9558] text-sm md:text-2xl">
                Sorry,your payment could not be processed .<br></br> Please try
                again or use a different method .
              </p>
            </div>
          </div>
          {/* <div>
                            <a href="/" >
                                <button id="btn" className='border-0 w-full hover:border hover:border-[#b39143] hover:bg-white hover:text-[#b39143] bg-[#b39143] h-12 md:h-16 rounded-full text-white py-2 md:py-3 md:text-2xl flex justify-center gap-2'>
                                    <img id="refreshwhite" className="w-6 h-6 md:w-8 md:h-8 mt-[0.2rem] md:mt-[0.2rem] lg:mt-[0.1rem]" src={refreshWhite} alt=""/>
                                    <img id="refreshYellow" className="hidden w-6 h-6 md:w-8 md:h-8 mt-[0.2rem] md:mt-[0.2rem] lg:mt-[0.1rem]" src={refreshYellow} alt=""/>
                                    <p className="pt-[0.1rem] md:pt-0">Try again</p>
                                </button>
                            </a>
                        </div> */}
        </div>
      </div>
    </div>
  );
};

export default PaymentFail;
